import * as React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useQueryClient } from "@tanstack/react-query";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { createMilestone } from "../../schemas/createMilestone";
import { RFHTextField as RHFTextField, RFHdatePicker, RHFTextEditor } from '../RFH'
import { createEpic } from "../../sevices/apiEpic";
import { useResponsive } from "../../hooks/useResponsive";
import useMutate from "../../hooks/useMutate";
import FormDialog from "../Dialog/FormDialog";
import useBoardIdByKey from "../../hooks/useBoardIdByKey";

export default function AddMilestone({ open, handleClose, title, btnTitle }) {
  const { id } = useBoardIdByKey();
  const queryClient = useQueryClient();
  const isMobile = useResponsive("down", "md");
  const methods = useForm({
    resolver: yupResolver(createMilestone),
    defaultValues: {
      epic_name: "",
      description: "",
    },
  });
  const { mutate, isPending } = useMutate(createEpic, [], () => {
    queryClient.invalidateQueries({
      queryKey: [`epic`, id],
    });
    methods.reset();
    handleClose();
  });

  const onSubmit = (formData) => {
    mutate({
      board_id: id,
      data: {
        ...formData,
        ...(formData.start_date && formData.target_release_date && {
          start_date: moment(formData.start_date).format("YYYY-MM-DD"),
          target_release_date: moment(formData.target_release_date).format(
            "YYYY-MM-DD"
          )
        })
      }
    });
};
return (
  <React.Fragment>
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <FormDialog
          open={open}
          handleClose={handleClose}
          handleSubmit={methods.handleSubmit(onSubmit)}
          title={title}
          buttonTxt={btnTitle}
          width={613}
          isLoading={isPending}
          cancelBtn={true}
          fullWidth={true}>
          <Typography className="milestone-lable">
            Milestone Name<span className="star">*</span>
          </Typography>
          <RHFTextField name={"epic_name"} />

          <Typography className="milestone-lable" mt={isMobile ? 1 : 2}>
            Description<span className="star">*</span>
          </Typography>
          <RHFTextEditor name={"description"} minHeight={"135px"} />
          <Stack
            direction="row"
            justifyContent={"space-between"}
            spacing={2.5}
            mt={isMobile ? "40px" : 2}>
            <Box sx={{ width: "100%" }}>
              <Typography className="milestone-lable">Start Date</Typography>
              <RFHdatePicker name="start_date" />
            </Box>
            <Box sx={{ width: "100%" }}>
              <Typography className="milestone-lable">Target Date</Typography>
              <RFHdatePicker name={"target_release_date"} />
            </Box>
          </Stack>
        </FormDialog>
      </form>
    </FormProvider>
  </React.Fragment>
);
}
